export enum CoverageApprovalTransactionType {
    None = 0,
    ExtendlPeriod = 1, 
    Transfer = 2,
    Renew = 3,
}